import { render, staticRenderFns } from "./StoreNavSettings.vue?vue&type=template&id=60076181&"
import script from "./StoreNavSettings.vue?vue&type=script&lang=js&"
export * from "./StoreNavSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports